import { metersBetweenLatLon } from "./geo_math"
import { WEB_MAP_POLICY } from "./web_policy"

export const AUTO_SEARCH_MOVE_THRESHOLD_M = WEB_MAP_POLICY.autoSearchMoveThresholdM

export function centerMovedSinceLastSearch(previous, current, thresholdM = AUTO_SEARCH_MOVE_THRESHOLD_M) {
  if (!previous) return true
  return metersBetweenLatLon(previous, current) > thresholdM
}

export function activeLayersNeedData(activeLayerKeys = [], featureCounts = {}) {
  return activeLayerKeys.length > 0 && activeLayerKeys.some(key => (featureCounts[key] || 0) === 0)
}

export function shouldAutoSearchAfterMove({
  forceNext = false,
  panMove = false,
  zoomMove = false,
  activeLayersNeedData: needsData = false,
  centerMoved = false
} = {}) {
  const zoomOnly = zoomMove && !panMove && !forceNext
  return !!(forceNext || needsData || (!zoomOnly && (panMove || centerMoved)))
}
